export default {
  // Titles
  time: "Time",

  // Placeholders
  pleaseSelect: "Please Select",
  startDate: "Start Date",
  endDate: "End Date",

  // Function Switch Options
  surveyData: "Survey Data",
  firstInflow: "First Inflow",
  swapContract: "Swap Contract",

  // Message Prompts
  currencyUpdateSuccess: "Currency updated successfully",
  timeUpdateSuccess: "Time updated successfully",
  tagUpdateSuccess: "Tag updated successfully",
  switchUpdateSuccess: "Switch updated successfully",
  filterSuccess: "Filter successful",
  updateSuccess: "Updated successfully!",
};
